import React from "react";
import {CHANGEVERSIONBUILD} from './constants';

//ROUTES
import Router from "./Routes";

//COMPONENTS
import GoogleAnalyticsInit from "./components/GoogleAnalyticsInit";

//I18N
import LangProvider from "./i18n/LangProvider";

//REDUX
import { Provider } from "react-redux";
import store from "./redux/store";

//CSS
import "bootstrap/dist/css/bootstrap.min.css";
import { esES } from '@material-ui/core/locale';
import {
  MuiThemeProvider,
  createMuiTheme,
  responsiveFontSizes
} from "@material-ui/core/styles";
const valuesBreak = {
  xs: 0,
  sm: 600,
  md: 768,
  lg: 1024,
  xl: 2560
};
let theme = createMuiTheme({
  breakpoints: {
    keys: ["xs", "sm", "md", "lg", "xl"],
    up: key => `@media (min-width:${valuesBreak[key]}px)`
  },
  palette: {
    primary: {
      light: "#DF7D44",
      main: "#DF7D44",
      dark: "#DF7D44"
    },
    secondary: {
      light: "#363636",
      main: "#363636",
      dark: "#363636"
    }
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        color: "white",
        textTransform: "none"
      },
      containedSecondary: {
        display: "inline",
        textTransform: "none"
      }
    }
  },
  typography: {
    fontFamily: "Allerta Stencil",
    useNextVariants: true
  }
}, esES);
theme.typography.subtitle2 = {
  fontSize: "0.875rem",
  [theme.breakpoints.down("md")]: {
    fontSize: "0.5rem"
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "0.775rem"
  }
};
theme = responsiveFontSizes(theme);

function App() {
  CHANGEVERSIONBUILD();
  
  return (
    <MuiThemeProvider theme={theme}>
      <Provider store={store}>
        <GoogleAnalyticsInit />
        <LangProvider>
          <Router />
        </LangProvider>
      </Provider>
    </MuiThemeProvider>
  );
}

export default App;
